function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import get from 'lodash/get';
import { TextInput } from '@domain-group/fe-co-form-elements';
import PropTypes from 'prop-types';
import * as styles from './size-filter.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var rangeValue = value => "".concat(value == null ? '' : value);
var fixRange = range => {
  var min = parseInt(range.min, 10);
  var max = parseInt(range.max, 10);
  return _objectSpread(_objectSpread({}, !Number.isNaN(min) && {
    min
  }), !Number.isNaN(max) && {
    max
  });
};
var rangeWithMin = (range, min) => fixRange({
  min,
  max: range ? range.max : null
});
var rangeWithMax = (range, max) => fixRange({
  min: range ? range.min : null,
  max
});
class SizeFilter extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onLowerChange", event => {
      this.props.onChange({
        [this.props.name]: rangeWithMin(this.props.size, event.target.value)
      });
    });
    _defineProperty(this, "onUpperChange", event => {
      this.props.onChange({
        [this.props.name]: rangeWithMax(this.props.size, event.target.value)
      });
    });
  }
  render() {
    return ___EmotionJSX("div", {
      css: styles.filter
    }, ___EmotionJSX("div", {
      css: styles.title
    }, "".concat(this.props.title, " (m\xB2)")), ___EmotionJSX("div", {
      css: styles.rangeContainer
    }, ___EmotionJSX(TextInput, {
      css: styles.input,
      name: "allhomes-search-more-options__size-to",
      type: "number",
      placeholder: "eg. 100",
      onChange: this.onLowerChange,
      value: rangeValue(get(this, 'props.size.min'))
    }), ___EmotionJSX("span", {
      css: styles.rangeText
    }, "to"), ___EmotionJSX(TextInput, {
      css: styles.input,
      name: "allhomes-search-more-options__size-from",
      type: "number",
      placeholder: "eg. 1000",
      onChange: this.onUpperChange,
      value: rangeValue(get(this, 'props.size.max'))
    })));
  }
}
SizeFilter.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  size: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
  }),
  onChange: PropTypes.func
};
SizeFilter.defaultProps = {
  size: {},
  onChange: () => {}
};
export default SizeFilter;